import { type PropsWithChildren, useMemo } from 'react';

import { message } from 'antd';

import { AntMessageContext } from '@/shared/lib/contexts';

interface AntMessageProviderProps extends PropsWithChildren {}

export function AntMessageProvider(props: AntMessageProviderProps) {
    const { children } = props;

    const [staticInstance, contextHolder] = message.useMessage({
        top: 0,
        maxCount: 1,
    });

    const defaultValue = useMemo(
        () => ({
            open: staticInstance.open,
            success: staticInstance.success,
            error: staticInstance.error,
            info: staticInstance.info,
            warning: staticInstance.warning,
            loading: staticInstance.loading,
            destroy: staticInstance.destroy,
        }),
        [staticInstance],
    );

    return (
        <AntMessageContext.Provider value={defaultValue}>
            {contextHolder}
            {children}
        </AntMessageContext.Provider>
    );
}
